import { ApiProperty } from "@nestjs/swagger";

export class SoakingRequestDto{
    @ApiProperty()
    soakingId:number;
    @ApiProperty()
    plantId:number;
    @ApiProperty()
    assertId:number;
    @ApiProperty()
    duration:number;
    @ApiProperty()
    StartTime:string;
    @ApiProperty()
    EndTime:string;
    @ApiProperty()
    date:Date;
    @ApiProperty()
    isActive:boolean;
    @ApiProperty()
    createdAt:Date;
    @ApiProperty()
    createdUser:string;
    @ApiProperty()
    updatedAt:Date;
    @ApiProperty()
    updatedUser:string;
    @ApiProperty()
    versionFlag:number;
   
}
